export default __webpack_public_path__ + "static/media/emptyGuideState.4d6a742e.png";